import { CDS_FP_LOGIN_PATH } from '../constants/cdsFrequentPassenger';
import getSafeCdsFpRedirectTarget from './getSafeCdsFpRedirectTarget';

/**
 * Builds a clean in-app redirect path for CDS FP login links.
 * Omits home and login routes so the auth URL stays without query noise.
 * @param {{ pathname?: string, search?: string, hash?: string } | string} locationOrRedirectUrl
 * @returns {string|undefined}
 */
export default function getCdsFpLoginRedirectUrl(locationOrRedirectUrl) {
  let path;

  if (typeof locationOrRedirectUrl === 'string') {
    path = getSafeCdsFpRedirectTarget(locationOrRedirectUrl, '');
  } else {
    const { pathname = '/', search = '', hash = '' } = locationOrRedirectUrl || {};
    path = `${pathname}${search}${hash}`;
  }

  if (!path || path === '/' || path.startsWith(CDS_FP_LOGIN_PATH)) {
    return undefined;
  }

  return path;
}
